<section class="ul-card" [class]="surfaceClass()">
  <header class="verdict-header">
    <div class="verdict-header-copy">
      <h3 class="surface-title">{{ 'requirementIntake.verdict.title' | translate }}</h3>
      <p class="workspace-caption">{{ 'requirementIntake.verdict.description' | translate }}</p>
    </div>
  </header>

  <section class="criteria-panel">
    <h4 class="subsection-title">{{ 'requirementIntake.verdict.questions.title' | translate }}</h4>

    @if (evidencesWithQuestions().length > 0) {
      <ol class="criteria-list">
        @for (evidence of evidencesWithQuestions(); track evidence.id) {
          <li class="criteria-item">
            <p>{{ evidence.name }}</p>
            <ol class="criteria-list">
              @for (question of evidence.questions; track question.id) {
                <li class="criteria-item">
                  {{ question.text }}
                  @if (question.abbreviation) {
                    <span class="abbreviation">[{{ question.abbreviation }}]</span>
                  }
                </li>
              }
            </ol>
          </li>
        }
      </ol>
    } @else {
      <p class="workspace-caption">{{ 'requirementIntake.verdict.questions.empty' | translate }}</p>
    }
  </section>

  @if (warnings().length > 0) {
    <section class="warning-banner" aria-live="polite">
      <h4 class="subsection-title">{{ 'requirementIntake.verdict.warning.title' | translate }}</h4>
      <ul class="warning-list">
        @for (warning of warnings(); track warning.key) {
          <li>{{ warning.key | translate: warning.params }}</li>
        }
      </ul>
    </section>
  }

  @if (showProposedVerdict()) {
    <section class="proposal-banner">
      <div class="proposal-banner-header">
        <span
          ><span class="proposal-label"
            >{{ 'requirementIntake.verdict.proposed.label' | translate }}
          </span>
          <span class="proposal-date"> {{ proposalDate() | date: 'short' }}</span>
        </span>
        <span [class]="resultBadgeClass(proposedResult())">
          {{ resultLabelKey(proposedResult()) | translate }}
        </span>
      </div>

      @if (requirement().verdict?.rationale) {
        <p
          class="proposal-rationale"
          compAiGeneratedContentDisclaimer
          [compAiGeneratedContentTextAlign]="'right'"
        >
          {{ requirement().verdict?.rationale }}
        </p>
      } @else {
        <p class="workspace-caption">
          {{ 'requirementIntake.verdict.proposed.noRationale' | translate }}
        </p>
      }
    </section>
  }

  <div
    class="choice-tiles"
    role="group"
    [attr.aria-label]="'requirementIntake.verdict.selection.aria' | translate"
  >
    <button
      type="button"
      class="choice-tile verdict-choice-pass"
      [class.selected]="selectedResult() === 'PASS'"
      [attr.aria-pressed]="selectedResult() === 'PASS'"
      (click)="selectResult('PASS')"
    >
      <span class="choice-body">
        <span class="choice-title">{{
          'requirementIntake.verdict.selection.pass.title' | translate
        }}</span>
        <span class="choice-hint">{{
          'requirementIntake.verdict.selection.pass.hint' | translate
        }}</span>
      </span>
    </button>

    <button
      type="button"
      class="choice-tile verdict-choice-fail"
      [class.selected]="selectedResult() === 'FAIL'"
      [attr.aria-pressed]="selectedResult() === 'FAIL'"
      (click)="selectResult('FAIL')"
    >
      <span class="choice-body">
        <span class="choice-title">{{
          'requirementIntake.verdict.selection.fail.title' | translate
        }}</span>
        <span class="choice-hint">{{
          'requirementIntake.verdict.selection.fail.hint' | translate
        }}</span>
      </span>
    </button>
  </div>

  <section class="justification-panel">
    <label class="field-label" for="verdictJustification">
      {{ 'requirementIntake.verdict.justification.label' | translate }}
    </label>
    <textarea
      id="verdictJustification"
      rows="4"
      [compAutofocus]="this.selectedResult() !== undefined"
      [compAutofocusTrigger]="this.selectedResult()"
      [value]="justification()"
      [placeholder]="'requirementIntake.verdict.justification.placeholder' | translate"
      (input)="onJustificationInput($event)"
    ></textarea>

    @if (isJustificationMissing()) {
      <p class="field-error" role="alert">
        {{ 'requirementIntake.verdict.justification.requiredError' | translate }}
      </p>
    }
  </section>

  <div class="action-row uls">
    <button type="button" comp-button [disabled]="isSaveDisabled()" (click)="saveVerdict()">
      {{
        isSubmitPending()
          ? ('requirementIntake.verdict.actions.saving' | translate)
          : ('requirementIntake.verdict.actions.save' | translate)
      }}
    </button>
  </div>

  @if (actionMessage(); as message) {
    <p class="workspace-caption">{{ message }}</p>
  }
</section>
